function Home() {
  return (
    <div>
      <h1>Trash</h1>
    </div>
  );
}
export default Home;
